import KitService from "@/services/KitService";

export const kit = {
  namespaced: true,
  state: {
    kit: {},
  },
  actions: {
    getKit({ commit }, payload) {
      return KitService.GetKit(payload).then(
        (kit) => {
          return Promise.resolve(kit);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postKit({ commit }, payload) {
      return KitService.PostKit(payload).then(
        (kit) => {
          return Promise.resolve(kit);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putKit({ commit }, payload) {
      return KitService.PutKit(payload).then(
        (kit) => {
          return Promise.resolve(kit);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteKit({ commit }, payload) {
      return KitService.DeleteKit(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getKitOData({ commit }, payload) {
      return KitService.GetKitOData(payload).then(
        (kit) => {
          return Promise.resolve(kit);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default kit;
